import { useEffect, useRef, useState } from "react";
import {
  CommitteeApprovalAssignmentConfig,
  CommitteeEventListConfig,
} from "../data/CommitteeApprovalAssignmentConfig";
import { useAssignCourseOrCpdToCommitteeApprovalMutation, useCommitteeApprovalAssignmentListMutation, useCommitteeCPDApprovalAssignmentListMutation } from "../../../app/services/CommitteeApprovalManagement/CommitteApprovalManagementApi";
import DatePicker from "../../../components/ui/inputs/datePicker/DatePicker";
import FinalMolGrid from "../../../components/FinalMolGrid/FinalMolGrid";
import SwalAlert from "../../../services/swalService/SwalService";
import Buttons from "../../../components/ui/button/Buttons";
import { getAuthProps } from "../../../lib/authenticationLibrary";

const CommitteeApprovalAssignmentList = () => {
  const molGrifRef = useRef();
  const [dataSource, setDataSource] = useState();
  const [cpddataSource, setCpdDataSource] = useState();
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
  });
  const { success } = SwalAlert();
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);

  const [committeeApprovalAssignmentList, { isSuccess: isSuccessCommitteeApprovalAssignment, isLoading: isLoadingCommitteeApprovalAssignment, data: getCommitteeApprovalAssignmentDataResponse, },] = useCommitteeApprovalAssignmentListMutation();
  const [committeeApprovalCpdAssignmentList, { isSuccess: isSuccessCommitteeApprovalCpdAssignment, isLoading: isLoadingCommitteeApprovalCpdAssignment, data: getCommitteeApprovalAssignmentCpdDataResponse, },] = useCommitteeCPDApprovalAssignmentListMutation();
  const [assignCourseOrCpdToCommitteeApproval, { isSuccess: isSuccessAssignCourseOrCpdToCommitteeApproval, isLoading: isLoadingAssignCourseOrCpdToCommitteeApproval, data: getAssignCourseOrCpdToCommitteeApprovalResponse, },] = useAssignCourseOrCpdToCommitteeApprovalMutation();

  useEffect(() => {
    
    committeeApprovalAssignmentList(paginationRequest);
    committeeApprovalCpdAssignmentList(paginationRequest);
  }, []);

  useEffect(() => {
    if (!isLoadingCommitteeApprovalAssignment && isSuccessCommitteeApprovalAssignment && getCommitteeApprovalAssignmentDataResponse) {
      setPaginationRequest((prev) => ({ ...prev, totalCount: getCommitteeApprovalAssignmentDataResponse.totalCount, }));
      setDataSource(getCommitteeApprovalAssignmentDataResponse?.itemList);
    }
  }, [isLoadingCommitteeApprovalAssignment, isSuccessCommitteeApprovalAssignment, getCommitteeApprovalAssignmentDataResponse,]);

  useEffect(() => {
    if (!isLoadingCommitteeApprovalCpdAssignment && isSuccessCommitteeApprovalCpdAssignment && getCommitteeApprovalAssignmentCpdDataResponse) {
      setPaginationRequest((prev) => ({ ...prev, totalCount: getCommitteeApprovalAssignmentCpdDataResponse.totalCount, }));
      setCpdDataSource(getCommitteeApprovalAssignmentCpdDataResponse?.itemList);
    }
  }, [isLoadingCommitteeApprovalCpdAssignment, isSuccessCommitteeApprovalCpdAssignment, getCommitteeApprovalAssignmentCpdDataResponse,]);

  useEffect(() => {
    if (!isLoadingAssignCourseOrCpdToCommitteeApproval && isSuccessAssignCourseOrCpdToCommitteeApproval && getAssignCourseOrCpdToCommitteeApprovalResponse) {
      success("Committee Approval Assignment Successfully")
      committeeApprovalAssignmentList(paginationRequest)
      committeeApprovalCpdAssignmentList(paginationRequest)
    }
  }, [isLoadingAssignCourseOrCpdToCommitteeApproval, isSuccessAssignCourseOrCpdToCommitteeApproval, getAssignCourseOrCpdToCommitteeApprovalResponse,]);

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = {
      ...paginationRequest,
      pageNo: pageNumber,
      pageSize: pageSize,
    };
    setPaginationRequest(updatedPaginationRequest);
    committeeApprovalAssignmentList(updatedPaginationRequest);
    committeeApprovalCpdAssignmentList(updatedPaginationRequest);
  };

  const handleRowSelection = (selectedRow) => {
    const batchNo = getCommitteeApprovalAssignmentDataResponse?.itemList[0]?.batchNo || 1 ;
    const cpdBatchNo = getCommitteeApprovalAssignmentCpdDataResponse?.itemList[0]?.cpdBatchNo || 1 ;
    const currentBatchNo = Math.max(batchNo, cpdBatchNo);

    setSelectedRows((prevSelectedRows) => {
      const updatedRows = prevSelectedRows ? [...prevSelectedRows] : [];
      const newSelectedRow = { ...selectedRow, batchNo: currentBatchNo };
      const isCpidType = !!selectedRow.cpidNumber;
      const matchFn = isCpidType ? (row) => row.cpidNumber === selectedRow.cpidNumber : (row) => row.eventNumber === selectedRow.eventNumber;
      const existingIndex = updatedRows.findIndex(matchFn);

      if (existingIndex !== -1) {
        const existingRow = updatedRows[existingIndex];
        if ((existingRow.batchNo ?? 0) < currentBatchNo) {
          updatedRows[existingIndex] = newSelectedRow;
        } else {
        }
        return updatedRows;
      }
      return [...updatedRows, newSelectedRow];
    });
  };

  const handleAssign = () => {
    let authData = getAuthProps();

    const request = {
      AssignCourseOrCpd: selectedRows.map((item) => ({
        CPIDNumber: item?.cpidNumber || null,
        BatchNo: item?.batchNo || null,
        LinkCloseDate: selectedDate || defaultDate,
        EventNumber: item?.eventNumber || null,
        UpdatedBy : 115,
        UpdatedAppId : authData?.adminUserId
      })),
    };
    assignCourseOrCpdToCommitteeApproval(request);
  };

  const defaultDate = new Date();
  defaultDate.setDate(defaultDate.getDate() + 7);

  return (
    <>
      <div>
        {/* <div className="commitee-table-title">Committee List: {getCommitteeApprovalAssignmentDataResponse?.totalCount}</div> */}
        <div className="list-card no-action-table">
          <div className="list-title">Course Provider</div>
          <FinalMolGrid
            ref={molGrifRef}
            configuration={CommitteeApprovalAssignmentConfig}
            dataSource={dataSource}
            allowPagination={true}
            isLoading={isLoadingCommitteeApprovalAssignment}
            pagination={paginationRequest}
            onPageChange={handlePageChange}
            onHandleRowSelect={handleRowSelection}
          />
        </div>
        <div className="list-card no-action-table">
          <div className="list-title">Events</div>
          <FinalMolGrid
            ref={molGrifRef}
            configuration={CommitteeEventListConfig}
            dataSource={cpddataSource}
            allowPagination={true}
            isLoading={isLoadingCommitteeApprovalCpdAssignment}
            pagination={paginationRequest}
            onPageChange={handlePageChange}
            onHandleRowSelect={handleRowSelection}
          />
        </div>
        <div className="date-sec">
          <div className="date-lable">Link Close Date</div>
          <DatePicker
            label="Link Close Date"
            id="linkCloseDate"
            selected={selectedDate || defaultDate}
            onChange={(date) => setSelectedDate(date)}
            // name={name}
            // placeholder={placeholder}
            className="datepicker-field"
          // onChange={handleDateChange}
          // onBlur={handleDatePickerBlur}
          // isDisable={formSetting?.isViewOnly || datePickerProps?.isDisable}
          // minDate={datePickerProps?.minDate}
          // {...datePickerProps}
          />
        </div>
        <div className="list-btn-sec">
          <button type="button" className="black-btn btn">
            Back
          </button>
          {isLoadingAssignCourseOrCpdToCommitteeApproval ?
            <Buttons
              buttonText="Loading..."
              isLoading={isLoadingAssignCourseOrCpdToCommitteeApproval}
              className="btn success-btn"
              isDisable={isLoadingAssignCourseOrCpdToCommitteeApproval}
            /> :
            <Buttons
              buttonText={"Assign"}
              buttonTypeClassName="success-btn  btn"
              onClick={handleAssign}
            />
          }
        </div>
      </div>
    </>
  );
};
export default CommitteeApprovalAssignmentList;
